var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("COMMON_CHANGESTATUS"),
        visible: "",
        width: "40%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("PAGE_PBC_CHANGETO"), prop: "status" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("COMMON_SELECT") },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                _vm._l(_vm.statusListFit, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.form.status == "3"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("PAGE_PBC_COMMENTS"),
                    prop: "comments",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.form.comments,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "comments", $$v)
                      },
                      expression: "form.comments",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }